import { render, staticRenderFns } from "./DeliverEdit.vue?vue&type=template&id=2078fc9a&scoped=true"
import script from "./DeliverEdit.vue?vue&type=script&lang=js"
export * from "./DeliverEdit.vue?vue&type=script&lang=js"
import style0 from "./DeliverEdit.vue?vue&type=style&index=0&id=2078fc9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2078fc9a",
  null
  
)

export default component.exports